import { render, staticRenderFns } from "./Points_Summary_Customer.vue?vue&type=template&id=32756ab8&scoped=true&"
import script from "./Points_Summary_Customer.vue?vue&type=script&lang=js&"
export * from "./Points_Summary_Customer.vue?vue&type=script&lang=js&"
import style0 from "./Points_Summary_Customer.vue?vue&type=style&index=0&id=32756ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32756ab8",
  null
  
)

export default component.exports